import { Component, input } from '@angular/core'
import { Order } from 'src/app/shared/interfaces/orders/order.interface'
import { CardComponent } from '../../card/card.component'
import { CardFooterDirective } from 'src/app/shared/directives/card/card-footer.directive'
import { RouterLink } from '@angular/router'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { TableModule } from '../../table/table.module'
import { DatePipe, SlicePipe } from '@angular/common'
import { CardHeaderDirective } from 'src/app/shared/directives/card/card-header.directive'

@Component({
    selector: 'sf-order-card',
    imports: [
        RouterLink,
        TableModule,
        ButtonComponent,
        CardComponent,
        CardFooterDirective,
        CardHeaderDirective,
        SlicePipe,
        DatePipe,
    ],
    templateUrl: './order-card.component.html',
    styleUrl: './order-card.component.scss',
})
export class OrderCardComponent {
    order = input.required<Order>()

    displayCount = 3

    toggleShowAll() {
        this.displayCount = this.displayCount === 3 ? this.order().items.length : 3
    }
}
